<template>
    <div class="">
        <div class="max-w-screen-xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
            <h2 class="text-3xl leading-9 pb-4 md:pb-12 font-extrabold text-gray-900 sm:text-2xl sm:leading-10">
                Alarm Activity
            </h2>
            <div class="mt-0 md:mt-6 border-gray-200 pt-0 md:pt-6">
                <dl>
                    <div class="mt-3 border-t border-gray-200 pt-6 md:grid md:grid-cols-12 md:gap-8" v-for="comment in comments.slice().reverse()">
                        <dt class="text-base leading-6 font-medium text-gray-900 md:col-span-5 text-center md:text-left">
                            <p class="text-lg text-blue-800 mb-2 md:mb-4">{{ comment.user_name }}</p>
                            <p class="text-sm text-gray-600 mb-2">{{ comment.date }}</p>
                            <span :class="getBadgeColor(comment)">{{ comment.comment_type }}</span>
                        </dt>
                        <dd class="mt-2 md:mt-0 md:col-span-7">
                            <p class="text-base leading-6 text-gray-500 whitespace-pre-wrap">
                                {{ comment.comment }}
                            </p>
                        </dd>
                    </div>
                </dl>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "alarmComments",
        props: {
            'comments': {},
        },
        methods: {
            getBadgeColor(comment){
                if(comment.badge_color === 'gray'){
                    return 'inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium leading-5 bg-gray-100 text-gray-800';
                }
                if(comment.badge_color === 'red'){
                    return 'inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium leading-5 bg-red-100 text-red-800';
                }
                if(comment.badge_color === 'green'){
                    return 'inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium leading-5 bg-green-100 text-green-800';
                }
                if(comment.badge_color === 'yellow'){
                    return 'inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium leading-5 bg-yellow-100 text-yellow-800';
                }
                if(comment.badge_color === 'blue'){
                    return 'inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium leading-5 bg-blue-100 text-blue-800';
                }
            },
        }
    }
</script>

<style scoped>

</style>